import { ReactElement, Suspense } from 'react';
import { Typography, Spin } from 'antd';
import { ApplicationTable, StyledRow, Cell } from './styles';
import Rows from './Rows';

const { Title } = Typography;

const List = (): ReactElement => {
  return (
    <section>
      <Title level={4}>架電履歴</Title>
      <ApplicationTable>
        <StyledRow>
          <Cell>ID</Cell>
          <Cell>RPM応募者ID</Cell>
          <Cell>電話番号</Cell>
          <Cell>氏名</Cell>
          <Cell>氏名（カナ）</Cell>
          <Cell>申込者ステータス</Cell>
          <Cell>架電結果</Cell>
          <Cell>架電日時</Cell>
        </StyledRow>
        <Suspense fallback={<Spin />}>
          <Rows />
        </Suspense>
      </ApplicationTable>
    </section>
  );
};

export default List;
